/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_New_No_PermissionInputs */



/**
* | output |
* | --- |
* | "Only NCs and ICs can create leagues." |
*
* @param {League_New_No_PermissionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_new_no_permission = /** @type {((inputs?: League_New_No_PermissionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_New_No_PermissionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les NC et IC peuvent créer des ligues.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los NC e IC pueden crear ligas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Apenas NC e IC podem criar ligas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo i NC e IC possono creare campionati.")
	return /** @type {LocalizedString} */ ("Only NCs and ICs can create leagues.")
});